/** Sidebar chrome. Message body uses `factoryAgentMessageClassName`. */
export const factoryAgentFontClassName =
  "factory-agent-sidebar font-inter [font-feature-settings:'cv02','cv03','cv04','cv11'] text-[13px] font-normal leading-[19.5px] tracking-[-0.01em] antialiased";

/** Transcript and composer body: 15px / 400, matching the factory canvas title size. */
export const factoryAgentMessageClassName =
  "factory-agent-message text-[15px] font-normal leading-[22.5px] tracking-[-0.01em]";

export const factoryAgentComposerTextClassName =
  "factory-agent-message px-3 py-2.5 font-inter text-[15px] font-normal leading-[22.5px] tracking-[-0.01em]";

export const factoryAgentIconButtonClassName =
  "size-7 shrink-0 rounded-full text-muted-foreground hover:bg-accent hover:text-foreground";
